import type { JSX, PropsWithChildren } from 'react';

import { Radio } from '@change-corgi/design-system-legacy/components/forms';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { useSunriseHoldoutExperiment } from '../../sunriseHoldoutExperiment/hooks/useSunriseHoldoutExperiment';
import { HighlightText } from '../HighlightText';

import { useSelectionCard } from './hooks/useSelectionCard';
import { RadioLabel } from './RadioLabel';
import { containerStyles, contentBoxStyles, radioStyles } from './styles';

export type Props = PropsWithChildren<{
	highlight?: string;
	label: string;
	message: string;
	onSelect: () => void;
	checked: boolean;
	qaSelectorSelection: string;
	qaSelectorLabel: string;
	qaSelectorMessage: string;
	isSunriseEnabled: boolean;
}>;

// TODO: Improve the complexity of this component once the sunrise experiments are productized

export function Selection({
	qaSelectorSelection,
	qaSelectorLabel,
	qaSelectorMessage,
	label,
	message,
	highlight,
	onSelect,
	checked,
	children,
	...props
}: Props): JSX.Element {
	const { isSunriseEnabled } = useSunriseHoldoutExperiment({
		checked,
		isSunriseEnabled: props.isSunriseEnabled,
	});

	const { data: koiPpmuDesignExperimentVariantStyles } = useSelectionCard(checked);

	return (
		<Box
			sx={containerStyles({
				checked,
				borderBackgroundColor: koiPpmuDesignExperimentVariantStyles.borderBackgroundColor,
				borderColor: koiPpmuDesignExperimentVariantStyles.borderColor,
			})}
			onClick={onSelect}
		>
			{highlight && <HighlightText text={highlight} selected={checked} isSunriseEnabled={isSunriseEnabled} />}
			<Box
				sx={contentBoxStyles({
					checked,
					highlight,
					backgroundColor: koiPpmuDesignExperimentVariantStyles.backgroundColor,
				})}
			>
				<Radio
					data-qa={qaSelectorSelection}
					data-testid="selection-radio"
					checked={checked}
					readOnly
					sx={radioStyles}
					label={
						<RadioLabel
							qaSelectorLabel={qaSelectorLabel}
							qaSelectorMessage={qaSelectorMessage}
							label={label}
							message={message}
						>
							{children}
						</RadioLabel>
					}
				/>
			</Box>
		</Box>
	);
}
